import { ListColumn, ListColumnAlignment } from '@/interfaces'
import { computed } from 'vue'

const aiGeneratedCols = computed<ListColumn[]>(() => {
  return [
    {
      name: 'title',
      title: 'video-drafts-title',
      width: 20,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      offset: 140,
      position: 1,
      priority: 1,
      expand: true
    },
    {
      name: 'duration_in_ms',
      title: 'library-filters-duration',
      width: 10,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 2,
      priority: 2
    },
    {
      name: 'is_vertical',
      title: 'settings-content-content-sources-orientation',
      width: 15,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 3,
      priority: 3
    },
    {
      name: 'ai_generated_article_url',
      title: 'ai-generated-url',
      width: 18,
      alignment: ListColumnAlignment.Center,
      sortable: false,
      position: 4,
      priority: 4
    },
    {
      name: 'is_paired_to_page',
      title: 'status',
      width: 12,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 5,
      priority: 5
    },
    {
      name: 'upload_date',
      title: 'content-uploaded-date',
      width: 10,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 6,
      priority: 6,
      minWidthInPx: '130px'
    },
    {
      name: 'actions',
      title: '',
      width: 7,
      alignment: ListColumnAlignment.Center,
      position: 7,
      priority: 0,
      minWidthInPx: '120px'
    }
  ]
})

export default aiGeneratedCols
